import { ready } from "@rootreeweb/js-lib";

import { getRawClassName, selectorToArray } from "./selectors.js";
import initTabs from "./tabs.js";

/** The main class for the extendo nav. */
class ExtendoNav {
	private readonly panels: HTMLDivElement[];
	private readonly topLevelItems: HTMLElement[];

	/** Creates an instance of Extendo Nav. */
	constructor() {
		this.topLevelItems = selectorToArray("mobileButton");
		this.panels = selectorToArray("panel");
		initTabs(); //This needs to be called before the panel heights are set.
		this.setPanelHeights();
		this.registerListeners();
		this.featureItemsLazyLoad();
	}

	/** Lazy loads the feature items by setting the background image. */
	private featureItemsLazyLoad(): void {
		const featureItems = selectorToArray("menuFeature");
		featureItems.forEach((featureItem) => {
			featureItem.style.backgroundImage = featureItem.dataset.img ?? "";
		});
	}

	/**
	 * Handles the click event on the toggle button.
	 *
	 * @param topLevelItem The top level item that was clicked.
	 * @param e The event that was triggered.
	 */
	private handleToggleClick(topLevelItem: HTMLElement, e: MouseEvent) {
		const openClass = getRawClassName("menuOpen");

		const li = topLevelItem.closest("li");
		const isOpen = li?.classList.contains(openClass);

		li?.classList.toggle(openClass, !isOpen);

		e.stopPropagation();
	}

	/** Add event listeners. */
	private registerListeners(): void {
		for (const topLevelItem of this.topLevelItems) {
			topLevelItem.addEventListener("click", (e) => {
				this.handleToggleClick(topLevelItem, e);
			});
		}

		window.addEventListener("resize", () => {
			this.setPanelHeights();
		});
	}

	/**
	 * Sets the height of the panels to the height of the tallest child for
	 * animation purposes.
	 */
	private setPanelHeights() {
		for (const panel of this.panels) {
			let height = panel.scrollHeight;
			const childrenAffectingHeight = selectorToArray("tabContent", panel);
			childrenAffectingHeight.forEach((child) => {
				if (child.scrollHeight > height) {
					height = child.scrollHeight;
				}
			});
			panel.style.setProperty("--panel-height", `${panel.scrollHeight}px`);
		}
	}
}

ready(() => new ExtendoNav());
